export enum SatAnalyticName {
  weeds = 'weeds',
  ndvi = 'ndvi',
  flowering = 'flowering',
  sugar = 'sugar',
  landUse = 'land-use',
  deforestation = 'deforestation',
  cropClassification = 'crop-classification',
  soilMoisture = 'soil-moisture'
}
export type SatAnalyticNameType =
  | SatAnalyticName.weeds
  | SatAnalyticName.ndvi
  | SatAnalyticName.flowering
  | SatAnalyticName.sugar
  | SatAnalyticName.landUse
  | SatAnalyticName.deforestation
  | SatAnalyticName.cropClassification
  | SatAnalyticName.soilMoisture;
